import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useAuth from '.';
import useSafeUser from '../useSafeUser';

export default function useNonAuthenticatedPage() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [isMounted, setIsMounted] = useState(false);
  const user = useSafeUser() as any;

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    // Add defensive checks to prevent navigation errors when store is not ready
    if (isMounted && typeof isAuthenticated === 'boolean' && isAuthenticated && user) {
      if (user.profileComplete) {
        navigate('/choose-template');
      } else {
        navigate('/complete-profile?tab=form');
      }
    }
  }, [isMounted, isAuthenticated, user, navigate]);
}
